import React, { useState } from "react";
import PopupWindow from "../../components/common/PopupWindow";

type ImagePopupWindowProps = {
    open: boolean,
    imgName: string,
    imgUrl: string,
    onCloseDialog: () => void,
    imgNote?: string
}

/**
 *   The Component is used to display enlarged image (full resolution) and provide the function to close dialog
 */
const ImagePopupWindow: React.FunctionComponent<ImagePopupWindowProps>= (props: ImagePopupWindowProps) => {
    const [resolution, setResolution] = useState({width:"", height:""})

    const onImgLoad = (event: any) => {
        setResolution({width:event.currentTarget.naturalWidth, height: event.currentTarget.naturalHeight} )
    }
    const imageNote = props.imgNote ? props.imgNote : "";

    return(
        <PopupWindow
            open={props.open}
            onCloseDialog={props.onCloseDialog}
            dialogTitle={`${props.imgName}(${resolution.width} x ${resolution.height} px) ${imageNote}`}
            childrenNode={<img src={props.imgUrl} alt={props.imgName} onLoad={onImgLoad}/>}>
        </PopupWindow>
    );
}

export default ImagePopupWindow;